import React from 'react';
import './App.css';
import Routes from './Routs';

function App() {
  return (
    <Routes />
  );
}

export default App;
